import { IContractManagementFilterRanges } from '@/contract-management/types/contract-management-filter-ranges';
import { IContractManagementFilter } from '@/contract-management/store/contract-management.store';

export function getDefaultFilter(
  filterRanges: IContractManagementFilterRanges,
  filter: IContractManagementFilter
): IContractManagementFilter {
  return {
    ...filter,
    tags: [],
    users: [],
    value: [filterRanges.minValue, filterRanges.maxValue],
    contractLength: [
      filterRanges.minContractLength,
      filterRanges.maxContractLength === 0
        ? filterRanges.maxContractLength + 10
        : filterRanges.maxContractLength,
    ],
    contractEndDate: [null, null],
    signDate: [null, null],
    documentType: filter.documentType,
    limit: 25,
    offset: 0,
  };
}

export function filterIsActive(
  defaultFilter: IContractManagementFilter,
  filter: IContractManagementFilter
): boolean {
  if (defaultFilter.tags.length !== filter.tags.length) {
    return true;
  }
  if (defaultFilter.users.length !== filter.users.length) {
    return true;
  }
  if (isRangeValuesChanged(defaultFilter.value, filter.value)) {
    return true;
  }
  if (isRangeValuesChanged(defaultFilter.contractEndDate, filter.contractEndDate)) {
    return true;
  }
  if (isRangeValuesChanged(defaultFilter.contractLength, filter.contractLength)) {
    return true;
  }
  if (isRangeValuesChanged(defaultFilter.signDate, filter.signDate)) {
    return true;
  }
  if (defaultFilter.documentType !== filter.documentType) {
    return true;
  }
  return false;
}

export const showInAllFolders = (
  filterActive: boolean,
  folderId: string,
  search: string[]
): boolean => {
  if (folderId) {
    return false;
  }
  return filterActive || search.length > 0;
};

function isRangeValuesChanged(
  defaultLength: string[] | number[],
  currentLength: string[] | number[]
): boolean {
  if (!defaultLength || defaultLength.length <= 0 || !currentLength || currentLength.length <= 0) {
    return;
  }
  return defaultLength[0] !== currentLength[0] || defaultLength[1] !== currentLength[1];
}
